<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc"></h2>
<p id="cover"><img alt="Story-Shaped Worship: Following Patterns from the Bible and History Cover" src="Images/9780830884292.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?3535ef06